<template>
  <BfwComponent :isReady="isReady" :title="title" :showTitle="showTitle" :editable="editable">
    <v-form ref="form" v-model="valid" lazy-validation :isReady="isReady">
      <v-row>
        <v-col>
          <JobsFilter v-model="jobs" @filterChanged="filteredJobIds = $event" state="open"></JobsFilter>

          <v-data-table dense :headers="headers" :items="tableData" :items-per-page="100" fixed-header height="100vh">
            <template v-slot:item.StartDate="{item}">
              <span>{{ item.StartDate ? item.StartDate.substr(0, 10) : "" }}</span>
            </template>

            <template v-slot:item.Name="{item}">
              {{ item.Name }}
              <v-chip v-if="item.is_complete" color="primary" small>Complete</v-chip>
            </template>

            <template v-slot:item.keywords="{item}">
              <span v-if="item.keywords.length > 0">
                <v-chip v-for="(keyword, index) in item.keywords" :key="index" small class="mr-1">
                  {{ keyword }}
                </v-chip>
              </span>
            </template>

            <template v-slot:item.actions="{item}">
              <div class="action-button-wrapper">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small dense class="action-button" color="primary"
                           :to="{ path: '/jobs/review', query: { JobId: item.ID }}" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-account-hard-hat</v-icon>
                    </v-btn>
                  </template>
                  <span>Job Review</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small dense class="action-button" color="primary"
                           :to="{ path: '/job-capacity', query: { JobId: item.ID }}" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-human-capacity-decrease</v-icon>
                    </v-btn>
                  </template>
                  <span>Job Forecast</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small dense class="action-button" color="primary" v-bind="attrs" v-on="on"
                           :href="item.WebUrl" target="_blank">
                      <v-icon>mdi-alpha-f</v-icon>
                    </v-btn>
                  </template>
                  <span>WorkflowMax Finance</span>
                </v-tooltip>

              </div>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
    </v-form>


  </BfwComponent>
</template>

<script>
import BfwComponent from "../BwfComponent"
import JobsFilter from "@/components/jobs/JobsFilter.vue"
import {toLocalString} from "@/lib/dateTimeUtilities"

export default {
  name: "JobsKeywordReport",
  permissions: ["Read Job"],
  components: {
    JobsFilter,
    BfwComponent,
  },
  methods: {
    reload() {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setFullYear(startDate.getFullYear() - this.$WfmApi.lookback)
      const start = toLocalString(startDate).substr(0, 10).replace(/-/g, "")
      const end = toLocalString(endDate).substr(0, 10).replace(/-/g, "")
      const query = {"from": start, "to": end, "detailed":true}

      this.$WfmApi.get("job.api/list", query).then(response => {
        this.jobs = response.Jobs.Job
        this.isReady = true
      })
      this.$BwfApi.get("jobs").then(response => {
        this.bwfJobs = response
      })
    },
    findBwfJob(jobId) {
      for (const bwfJob of this.bwfJobs) {
        if (bwfJob.job_id === jobId) {
          return bwfJob
        }
      }
      return false
    },
  },
  mounted() {
    this.reload()
  },
  computed: {
    tableData: function () {
      const tableData = []

      for (const item of this.jobs) {
        if (this.filteredJobIds.includes(item.ID)) {
          const bwfJob = this.findBwfJob(item.ID)
          console.log("bwfJob", bwfJob)
          tableData.push({
            ID: item.ID,
            UUID: item.UUID,
            Name: item.Name,
            client: item.Client.Name,
            StartDate: item.StartDate,
            DueDate: item.DueDate,
            WebUrl: item.WebURL.replace('/information', '/financials'),
            manager: item.Manager ? item.Manager.Name : "",
            is_complete: item.State === "Completed",
            keywords: bwfJob?.keywords || [],
          })
        }
      }
      return tableData
    }
  },
  data() {
    return {
      title: "Jobs Overview",
      showTitle: false,
      editable: false,
      isReady: false,
      filteredJobIds: [],
      jobs: [],
      bwfJobs: [],
      bwfInvoiceData: [],
      headers: [
        {text: "", value: "actions"},
        {text: "Job ID", value: "ID"},
        {text: "Job", value: "Name"},
        {text: "Client", value: "client"},
        {text: "Keywords", value: "keywords"},
        {text: "Manager", value: "manager"},
        {text: "Start Date", value: "StartDate"},
      ],
    }
  },
}

</script>

<style scoped>
td > div {
  display: inline-block;
}

.action-button {
  height: 25px !important;
  width: 25px !important;
  padding: 0;
  margin-right: 5px;
  min-width: auto !important;
}

.action-button-wrapper {
  width: 130px
}
</style>